module.exports = __webpack_public_path__ + "img/2023big18.d4ca5261.png";